<template>
  <a
    :href="claimUrl"
    target="_blank"
    class="flex items-center p-4 cursor-pointer no-underline"
    v-if="showClaim"
  >
    <ion-icon name="shield-checkmark-outline" class="fs-3 mr-1"></ion-icon>
    Claim this record
  </a>
</template>

<script>
import { claimUrl } from "@/app.config";

import { getNumIdFromNumUriString } from "@/utils/utils";

export default {
  name: "ClaimNumId",
  props: {
    isPopulated: Boolean,
    numUriString: String,
    queryLocation: String,
  },
  computed: {
    claimUrl() {
      return claimUrl(getNumIdFromNumUriString(this.numUriString));
    },
    showClaim() {
      return this.queryLocation !== "INDEPENDENT" && this.isPopulated;
    },
  },
};
</script>
